import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingTopUpsAmountForm({ fundingTopupsSum, fundingTopupsCount }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Top-ups Amount:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          align="right"
          className="bo-input"
          type="text"
          name="topups"
          id="topups"
          value={fundingTopupsSum}
          readOnly
        />
      </Col>
      <Col md={3} className="bo-same-line">
        ({fundingTopupsCount} top-ups)
      </Col>
    </>
  );
}

export default memo(FundingTopUpsAmountForm);
